/**
 * Assets del producto DPS66 · Ice Machine Diagnostic Pro.
 *
 * MAIN_MOCKUP_URL: mockup principal (hero y recuadro de precio). Vacío = se
 * muestra una pila de tapas diseñada con la identidad del producto.
 */
export const MAIN_MOCKUP_URL = ''

/**
 * Páginas reales del producto (exportadas de Gamma), formato horizontal.
 * Vacío = se muestra un esquema diseñado de esa página.
 */
export const PAGE_IMAGES = {
  formula: '',
  splitTree: '',
  fpc: '',
  compare: '',
  worksheet: '',
  fieldCard: '',
}
